import React from 'react';
import '../assets/LoadingSpinner.css'; 

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

export default LoadingSpinner;